<template>
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8 8.4H9.6V9.6H10.8V8.4Z" fill="#A1A1A1" />
        <path d="M12 15.6H10.8V16.8H12V15.6Z" fill="#A1A1A1" />
        <path d="M2.4 15.6H1.2L1.2 16.8H2.4V15.6Z" fill="#A1A1A1" />
        <path d="M12 15.6H13.2V4.8H12V15.6Z" fill="#A1A1A1" />
        <path d="M13.2 2.4V1.2L8.4 1.2V0L4.8 1.04907e-07V1.2H5.24538e-08L1.57361e-07 2.4H13.2Z" fill="#A1A1A1" />
        <path d="M12 4.8V3.6H1.2L1.2 4.8H12Z" fill="#A1A1A1" />
        <path d="M5.24538e-08 15.6H1.2L1.2 4.8H5.24538e-08V15.6Z" fill="#A1A1A1" />
        <path d="M10.8 18V16.8H2.4L2.4 18H10.8Z" fill="#A1A1A1" />
        <path d="M12.0002 4.80005H1.2002V15.6H2.4002V16.8H10.8002V15.6H12.0002V4.80005Z" fill="black" />
    </svg>
</template>

<script>
export default {
    name: "DeleteButton"
}
</script>